import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/main.scss';
import App from './App';
import { register } from './serviceWorkerRegistration';
import './i18n/i18n'; // Import i18n configuration
import { LanguageProvider } from './context/LanguageContext';

const container = document.getElementById('root');
if (!container) {
    throw new Error('Root element #root is missing from index.html');
}

ReactDOM.createRoot(container).render(
    <React.StrictMode>
        <LanguageProvider>
            <App />
        </LanguageProvider>
    </React.StrictMode>
);

register();
